import { EventEnum } from "enums/EventEnum";
import { Analytics } from "services/Analytics/Analytics";
import useTranslation from "translations/useTranslation";
import HelpSectionDouble from "./HelpSectionDouble";
import useConfigs from "hooks/useConfigs";
import useWindowOpenWithAnalytics from "hooks/useWindowOpenWithAnalytics";

export default function CookiesPolicy() {
    const t = useTranslation();
    const { url_tiendeo } = useConfigs();

    function handleConsentPreferences() {
        if (typeof window === "undefined" || !window.OneTrust) return;
        window.OneTrust.ToggleInfoDisplay();
        Analytics.Instance.sendEvent(EventEnum.Cookies);
    }

    const goToCookiePolicy = useWindowOpenWithAnalytics(
        `${url_tiendeo}/cookie-policy`,
        EventEnum.CookiePolicy,
    );

    return (
        <HelpSectionDouble
            buttonText={t("SEE")}
            paragraphText={t("PRIVACY_COOKIE_DETAIL")}
            titleText={t("COOKIE_POLICY")}
            onButtonClick={goToCookiePolicy}
            buttonTestId="help-show-cookies-policy"
            secondButtonText={t("CONSENT_PREFERENCES")}
            onSecondButtonClick={handleConsentPreferences}
            secondButtonTestId="help-manage-cookies-policy"
        />
    );
}
